import Swal from 'sweetalert2';

const COLORS = {
  navy: '#12263F',
  danger: '#C62828',
  muted: '#6B7280',
};

// Modal replacement for window.confirm — resolves true only if the user confirms.
export async function confirmAction({
  title = 'Are you sure?',
  text = '',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false,
} = {}) {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    width: 'auto',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: danger ? COLORS.danger : COLORS.navy,
    cancelButtonColor: COLORS.muted,
    reverseButtons: true,
  });
  return result.isConfirmed;
}

// Modal replacement for window.alert.
export function showAlert({ title = 'Something went wrong', text = '', icon = 'error' } = {}) {
  return Swal.fire({
    title,
    text,
    icon,
    width: 'auto',
    confirmButtonColor: COLORS.navy,
  });
}

// Brief, non-blocking success confirmation — doesn't require the user to dismiss it.
export function showSuccessToast(title) {
  return Swal.fire({
    title,
    icon: 'success',
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    animation: false,
  });
}
